import { FilterParametersFieldOptionsChoices } from 'common/module/filter/parameters/field-options-choices.interface';

// Strip out any fields apart of value and label
export const filterChoiceAdapter = <T>(choices: FilterParametersFieldOptionsChoices<T>) =>
  choices
    .map(({ value, label }) => ({ value: String(value), label }))
    // filter out the empty value
    .filter((choice) => choice.value !== '');
